import { Skeleton } from 'antd';
import API from 'API';
import { NotFound } from 'AppRoute';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Account from '../Account';
import { useAuth } from 'AuthContext';

export default function UserInfo() {
    const [info, setInfo] = useState(null);
    const { user } = useAuth();
    const [getting, setGetting] = useState(true);
    const { id } = useParams();

    useEffect(() => {
        setGetting(true);
        API.get(`/users/${id}`)
        .then(res => {
            setInfo(res.data);
        })
        .catch(error => {
            console.log(error);
        })
        .finally(() => {
            setGetting(false);
        })
    },[id])

    const hideList = ["username"];
    if (user.role === 100) {
        hideList.push("student_number");
        hideList.push("birthday");
    }

    return getting ? <Skeleton active /> : !info ? <NotFound />
    : <Account view userProp={info} hideList={hideList}/>
}
